import React, { memo, ReactNode } from "react";
import { ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ImageIcon from '@material-ui/icons/Image';
import { FileExtension } from "modules/shared/utility/file-extension";
interface DocumentUploadListItemProps {
    file: File;
    children?: ReactNode;
}

export const DocumentUploadListItem = memo(({ file, children }: DocumentUploadListItemProps) => {
    return (
        <ListItem>            
            <ListItemIcon>
                <DocumentFileIcon fileExtension={file.extension()} />
            </ListItemIcon>
            <ListItemText primary={file.name} />
            {children}
        </ListItem>
    );
});

DocumentUploadListItem.displayName = 'DocumentUploadListItem';

const DocumentFileIcon = memo(({ fileExtension }: { fileExtension: FileExtension }) => {
    if (fileExtension.isImage()) {  
            return <ImageIcon fontSize="small" />;
    } else {
        return <PictureAsPdfIcon fontSize="small" />;
    }
});

DocumentFileIcon.displayName = 'DocumentFileIcon';
